export default {"src":"/evde-internet/_next/static/media/location.ac85706a.svg","height":36,"width":36};